import React from "react";
import { FromErrorMessageProps } from "../../ts/FormType";

const ErrorMessage: React.FC<FromErrorMessageProps> = ({ message }) => {
  return <small className="text-danger font-weight-bold">{message}</small>;
};

export default ErrorMessage;
